import { gql } from '@apollo/client';

export const FETCH_STRUTTURE = gql`
  query FetchStrutture($where: StruttureWhereInput!) {
    struttures(where: $where) {
      edges {
        node {
          objectId
          nome
          nomeAlias
          citta
          frazione
          indirizzo
          cap
          provincia
          numero
          tipologia_struttura
          note
        }
      }
    }
  }
`;
